"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ProcessListItem_1 = __importDefault(require("./ProcessListItem"));
exports.default = ProcessListItem_1.default;
